import {
  toWSDateString,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import { InternalAccount } from "@wingspanhq/wingspan-api-sdk";
import { accountTypeToHumanReadable } from "../../utils/accountTypeToHumanReadable";
import { TableItemData } from "./TableStatements";

type ColumnsConfig = {
  internalAccount?: InternalAccount;
};

export const getColumns = ({
  internalAccount
}: ColumnsConfig): WSTableColumn<TableItemData>[] => [
  {
    config: {
      header: {
        text: "Statement period"
      },
      gridTemplateSizeMax: "1fr"
    },
    renderFunction: ({ data }) => (
      <WSTableCell
        text={`${toWSDateString(
          data.startDate,
          "monthDayYear"
        )} - ${toWSDateString(data.endDate, "monthDayYear")}`}
      />
    )
  },
  {
    config: {
      header: {
        text: "Account number"
      },
      gridTemplateSizeMax: "1fr",
      hideOnScreens: ["XS"]
    },
    renderFunction: () => (
      <WSTableCell text={internalAccount?.numbers?.account || "N/A"} />
    )
  },
  {
    config: {
      header: {
        text: "Account type"
      },
      gridTemplateSizeMax: "1fr"
    },
    renderFunction: ({ data }) => (
      <WSTableCell
        text={
          data.accountType ? accountTypeToHumanReadable(data.accountType) : "—"
        }
      />
    )
  },
  {
    config: {
      header: {
        text: "Partner bank"
      },
      hideOnScreens: ["XS"],
      gridTemplateSizeMax: "1fr"
    },
    renderFunction: () => <WSTableCell text="Lead Bank" />
  }
];
